import { call, take, put } from 'redux-saga/effects';
import { get, post } from '../../utils/api';
import { isEmpty } from 'lodash';
import settings from '../../utils/settings';
import { apiConfig } from './apiConfig';
import { getTempGeneratorTokenConfig } from '../../config/env';
import {
  GET_GENERATOR_TOKEN_INSTALLER_LIST_REQUEST,
  GET_GENERATOR_TOKEN_INSTALLER_LIST_SUCCESS,
  GET_GENERATOR_TOKEN_INSTALLER_LIST_FAILURE,
  GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_REQUEST,
  GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_SUCCESS,
  GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_FAILURE,
  GET_SUBCONTRACTOR_LIST_REQUEST,
  GET_SUBCONTRACTOR_LIST_SUCCESS,
  GET_SUBCONTRACTOR_LIST_FAILURE,
  ASSIGN_TOKENS_TO_SUBCONTRACTOR_REQUEST,
  ASSIGN_TOKENS_TO_SUBCONTRACTOR_SUCCESS,
  ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE,
  GET_STORE_URL_REQUEST,
  GET_STORE_URL_SUCCESS,
  GET_STORE_URL_FAILURE
} from './constants';
export function* getGeneratorTokenInstallerListFlow() {
  while (true) {
    const request = yield take(GET_GENERATOR_TOKEN_INSTALLER_LIST_REQUEST);
    const isProductionEnlm = (window.build_environment === 'production')
    const isQa4ENLM = (window.build_environment === 'qa4')
    console.log("Process.env.node_env:", process.env.NODE_ENV)
    console.log("process.env.REACT_APP_BUILD_ENV", process.env.REACT_APP_BUILD_ENV)
    try {
      const response = yield call(post, {
        url: `${(isProductionEnlm && getTempGeneratorTokenConfig())?
                settings.getTempGeneratorTokenUrl(apiConfig.installer_token_list): (isQa4ENLM)? 
                settings.getTempQaGeneratorUrl(apiConfig.installer_token_list): 
                settings.getApiUrl(`service/generator_token_ms/${apiConfig.installer_token_list}`)}`,
        // url: settings.getApiUrl(`service/generator_token_ms/api/installer_tokens/list`),
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_GENERATOR_TOKEN_INSTALLER_LIST_SUCCESS,
            generatorTokenInstallerList: response.result
          });
        } else {
          yield put({ type: GET_GENERATOR_TOKEN_INSTALLER_LIST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getDealerListFlow:', error);
      yield put({ type: GET_GENERATOR_TOKEN_INSTALLER_LIST_FAILURE, error: error });
    }
  }
}

export function* getGeneratorTokenInstallerListBulkFlow() {
  while (true) {
    const request = yield take(GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_REQUEST);
    const isProductionEnlm = (window.build_environment === 'production')
    const isQa4ENLM = (window.build_environment === 'qa4')

    try {
      const response = yield call(post, {
        url: `${(isProductionEnlm && getTempGeneratorTokenConfig())?
                settings.getTempGeneratorTokenUrl(apiConfig.installer_token_list):(isQa4ENLM)? 
                settings.getTempQaGeneratorUrl(apiConfig.installer_token_list):
                settings.getApiUrl(`service/generator_token_ms/${apiConfig.installer_token_list}`)}`,
        // url: settings.getApiUrl(`service/generator_token_ms/api/installer_tokens/list`),
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_SUCCESS,
            generatorTokenInstallerListBulk: response.result
          });
        } else {
          yield put({ type: GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getDealerListFlow:', error);
      yield put({ type: GET_GENERATOR_TOKEN_INSTALLER_LIST_BULK_FAILURE, error: error });
    }
  }
}

export function* getSubcontractorListFlow() {
  while (true) {
    const request = yield take(GET_SUBCONTRACTOR_LIST_REQUEST);
    const isProductionEnlm = (window.build_environment === 'production')
    const isQa4ENLM = (window.build_environment === 'qa4')

    try {
      const response = yield call(get, {
        url: `${(isProductionEnlm && getTempGeneratorTokenConfig())?
                settings.getTempGeneratorTokenUrl(apiConfig.authorized_subcontractor_list):(isQa4ENLM)? 
                settings.getTempQaGeneratorUrl(apiConfig.authorized_subcontractor_list):
                settings.getApiUrl(`service/generator_token_ms/${apiConfig.authorized_subcontractor_list}`)}`,
        // url: settings.getApiUrl(`service/generator_token_ms/api/authorized_subcontractors/list`),
        // body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_SUBCONTRACTOR_LIST_SUCCESS,
            subcontractorList: response.result
          });
        } else {
          yield put({ type: GET_SUBCONTRACTOR_LIST_FAILURE, error: result.message });
        }
      }
    } catch (error) {
      console.log('Saga: getDealerListFlow:', error);
      yield put({ type: GET_SUBCONTRACTOR_LIST_FAILURE, error: error });
    }
  }
}

export function* assignTokensToSubcontractorFlow() {
  while (true) {
    const request = yield take(ASSIGN_TOKENS_TO_SUBCONTRACTOR_REQUEST);
    const isProductionEnlm = (window.build_environment === 'production')
    const isQa4ENLM = (window.build_environment === 'qa4')

    try {
      const response = yield call(post, {
        url: `${(isProductionEnlm && getTempGeneratorTokenConfig())?
                settings.getTempGeneratorTokenUrl(apiConfig.assign_to_subcontractor):(isQa4ENLM)? 
                settings.getTempQaGeneratorUrl(apiConfig.assign_to_subcontractor):
                settings.getApiUrl(`service/generator_token_ms/${apiConfig.assign_to_subcontractor}`)}`,
        // url: settings.getApiUrl(`service/generator_token_ms/api/installer_tokens/assign_to_subcontractor`),
        body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: ASSIGN_TOKENS_TO_SUBCONTRACTOR_SUCCESS,
            assignResult: response.result.data
          });
        } else {
          yield put({ type: ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE, error: response.result.data });
        }
      } else {
        yield put({ type: ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE, error: response.result.data });
      }
    } catch (error) {
      console.log('Saga: getDealerListFlow:', error);
      yield put({ type: ASSIGN_TOKENS_TO_SUBCONTRACTOR_FAILURE, error: error });
    }
  }
}

export function* getStoreUrlFlow() {
  while (true) {
    const request = yield take(GET_STORE_URL_REQUEST);
    const isProductionEnlm = (window.build_environment === 'production')
    const isQa4ENLM = (window.build_environment === 'qa4')

    try {
      const response = yield call(get, {
        url: `${(isProductionEnlm && getTempGeneratorTokenConfig())?
                settings.getTempGeneratorTokenUrl(apiConfig.purchase_token_cart):(isQa4ENLM)? 
                settings.getTempQaGeneratorUrl(apiConfig.purchase_token_cart): 
                settings.getApiUrl(`service/generator_token_ms/${apiConfig.purchase_token_cart}`)}`,
        // url: settings.getApiUrl(`service/generator_token_ms/api/purchase_tokens/carts_url`),
        // body: request.payload
      });
      if (response.success) {
        const { result } = response;
        if (result) {
          yield put({
            type: GET_STORE_URL_SUCCESS,
            storeUrl: response.result.cart_url
          });
        } else {
          yield put({ type: GET_STORE_URL_FAILURE, error: result });
        }
      } else {
        yield put({ type: GET_STORE_URL_FAILURE, error: response.result });
      }
    } catch (error) {
      yield put({ type: GET_STORE_URL_FAILURE, error: error });
    }
  }
}